import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class DocumentationApi {

    static async getAllProcesses(plantId?: string) {
        const params = plantId ? { plantId } : {};
        const response = await ApiHandler(baseURL).get('documentation', { params });
        return response.data;
    }

    static async getProcessById(processId: string, plantId?: string) {
        const params = plantId ? { plantId } : {};
        const response = await ApiHandler(baseURL).get(`documentation/${processId}`, { params });
        return response.data;
    }

    static async getModules() {
        const response = await ApiHandler(baseURL).get('documentation/modules');
        return response.data;
    }
}
